module.exports = __webpack_public_path__ + "static/media/icon-character__joan-miro.4993128f.svg";